import script from "./OrganizationsMgmtPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationsMgmtPage.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationsMgmtPage.vue?vue&type=style&index=0&id=59def182&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59def182"]])

export default __exports__